import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import CustomPagination from "./CustomPagination";

interface CursorProps {
  mode: "cursor";
  canGoBack: boolean;
  hasMore: boolean;
  onPrevious: () => void;
  onNext: () => void;
  label?: React.ReactNode;
}

interface Props {
  mode?: "pages";
  pageCount: number;
  currentPage: number;
  pageRangeDisplayed?: number;
  marginPagesDisplayed?: number;
  hrefBuilder?: (
    pageIndex: number,
    pageCount: number,
    selectedPage: number
  ) => void;
  onPageChange: (page: number) => void;
}

const CURSOR_BUTTON =
  "flex min-h-[38px] items-center justify-center rounded-md border px-3 py-1.5 transition-colors disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500";

const Pagination = (props: Props | CursorProps) => {
  if (props.mode === "cursor") {
    const { canGoBack, hasMore, onPrevious, onNext, label } = props;
    return (
      <div className="react-paginate">
        <div className="flex flex-row items-center">
          <button
            type="button"
            onClick={onPrevious}
            disabled={!canGoBack}
            className={CURSOR_BUTTON}
          >
            <FaChevronLeft />
          </button>
          {label !== undefined && (
            <span className="px-3 text-sm tabular-nums text-gray-600">
              {label}
            </span>
          )}
          <button
            type="button"
            onClick={onNext}
            disabled={!hasMore}
            className={CURSOR_BUTTON}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    );
  }

  const { pageCount, pageRangeDisplayed, onPageChange, currentPage } = props;
  const handlePageChange = (selectedItem: { selected: number }) => {
    onPageChange(selectedItem.selected);
  };

  return (
    <CustomPagination
      previousLabel={<FaChevronLeft />}
      nextLabel={<FaChevronRight />}
      pageCount={pageCount}
      onPageChange={handlePageChange}
      pageRangeDisplayed={pageRangeDisplayed || 2}
      breakLabel={"..."}
      pageLinkClassName=""
      previousClassName=""
      nextClassName=""
      disabledClassName={
        "cursor-not-allowed disabled-pagination bg-gray-100 text-gray-500"
      }
      breakClassName={"break-me"}
      containerClassName={"react-paginate"}
      activeClassName={""}
      forcePage={currentPage}
    />
  );
};

export default Pagination;
